import React, { useState, useEffect } from 'react';
import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  Typography,
} from '@one-thd/sui-atomic-components';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import { ArrowForward } from '@one-thd/sui-icons';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { QuickView } from '@thd-olt-component-react/quick-view';
import useBundleDrawer from '../../hooks/useBundleDrawer';
import logNewRelicCustom from '../../utils/logNewRelicCustom';
import { useProductDataStore, useProductInfoStore } from '../../store';
import { NEW_RELIC_EVENTS } from '../../constants';

export const DrawerLoader = () => (
  <div />
);

const renderList = (bundle, productData, handleOpenQuickView) => _map(bundle.bundleSkus, (sku) => {
  const label = productData?.[sku]?.identifiers?.productLabel;
  const imgUrl = productData?.[sku]?.media?.images?.[0]?.url.replace(/<SIZE>/, '200');

  return (
    <div
      tabIndex={0}
      className="summary-line-item sui-pb-4"
      role="button"
      onClick={() => handleOpenQuickView(sku)}
      key={sku}
    >
      <div className="sui-flex sui-flex-row sui-justify-between">
        <div className="sui-pr-2 sui-pt-4">
          <img
            alt="line-item"
            src={imgUrl}
            className="line-item-image"
            height="200px"
            width="200px"
          />
        </div>
        <div className="sui-flex sui-flex-col sui-w-full sui-pt-4 sui-justify-center">
          <div className="sui-pb-2">
            {label}
          </div>
        </div>
        <div className="sui-flex sui-flex-col sui-pt-4 sui-justify-center">
          <ArrowForward color="brand" />
        </div>
      </div>
    </div>
  );
});

const BundleDrawer = () => {
  const { bundle, isOpen, closeDrawer } = useBundleDrawer();
  const productData = useProductDataStore((state) => state.productData);
  const productInfo = useProductInfoStore((state) => state.productInfo);
  const [drawerTitle, setDrawerTitle] = useState('');
  const [quickView, setQuickView] = useState({
    isOpen: false,
    itemId: null,
  });

  useEffect(() => {
    if (productInfo) {
      setDrawerTitle(`${productInfo.brand} ${productInfo.displayName}`);
    }
  }
  , [productInfo]);

  const handleCloseDrawer = () => {
    closeDrawer();
  };

  const handleOpenQuickView = (sku) => {
    setQuickView({ isOpen: true, itemId: sku });
    logNewRelicCustom(NEW_RELIC_EVENTS.BUNDLE_SUB_QUICK_VIEW, { itemId: sku });
  };

  const handleCloseQuickView = () => {
    setQuickView({ isOpen: false, itemId: null });
  };

  return (
    <div>
      <Drawer
        open={isOpen}
        onClose={handleCloseDrawer}
        position="right"
        DrawerRootProps={{
          style: { minHeight: '100%' },
          'data-sub-experience': 'product',
          'data-component': 'BundleQVDrawer'
        }}
      >
        <DrawerHeader title={`${drawerTitle} Bundle`} onClose={handleCloseDrawer} />
        <Typography
          variant="body-base"
          style={{
            paddingLeft: '2rem',
            paddingBottom: '1rem',
            borderBottom: '2px solid #ccc',
            borderTop: '2px solid #ccc',
            paddingTop: '1rem'
          }}
        >
          Pick an item to view more details
        </Typography>
        <DrawerBody>{renderList(bundle, productData, handleOpenQuickView)}</DrawerBody>
      </Drawer>
      {quickView?.itemId && (
        <div data-component="BundleQVDrawer">
          <QueryProvider cacheKey="quick-view-bundle-drawer">
            <QuickView
              itemId={String(quickView?.itemId)}
              isOpen={quickView?.isOpen}
              onClose={handleCloseQuickView}
            />
          </QueryProvider>
        </div>
      )}
    </div>
  );
};

export default BundleDrawer;
